module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/eye-invisible-icon.9fcf91e4.svg";